module.exports = __webpack_public_path__ + "static/media/logo-pr-crm.c44a2f61.svg";